import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { conversionList as conversionListFbu } from '@/api/gucangSales/customerCenter'
import { conversionList as conversionListOfbu } from '@/api/overseasSales/customerCenter'
import { conversionList as conversionListLbu } from '@/api/yuntuSales/customerCenter'
import { tableIdByPath } from '@/utils'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'TabsConversion' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  resourceId: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: true
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
},
  setup(__props) {

const { t } = useI18n()
const props = __props
const conversionListMethod = {
  cos_fbu: conversionListFbu,
  cos_ofbu: conversionListOfbu,
  cos_lbu: conversionListLbu
}
const fetch = (params: object, callBack: (res: any) => void) => {
  if (props.resourceId) {
    conversionListMethod[props.appId]({
      resourceId: props.resourceId,
      ...params
    }).then((res: any) => {
      callBack(res)
    })
  }
}
const columns = computed(() => [
  { title: t('common.operator'), dataIndex: 'createByName' },
  { title: t('common.operatorDate'), dataIndex: 'createTime' },
  {
    title: t('common.operationType'),
    dataIndex: 'operateType'
    // dicData: [
    //   { label: t('enum.operateType1'), value: 1 },
    //   { label: t('enum.operateType2'), value: 2 },
    //   { label: t('enum.operateType3'), value: 3 },
    //   { label: t('enum.operateType4'), value: 4 },
    //   { label: t('enum.operateType5'), value: 5 },
    //   { label: t('enum.operateType6'), value: 6 },
    //   { label: t('enum.operateType7'), value: 7 },
    //   { label: t('enum.operateType8'), value: 8 },
    //   { label: t('enum.operateType9'), value: 9 }
    // ]
  },
  { title: t('common.operatorBefore '), dataIndex: 'beforeData' },
  { title: t('common.operatorAfter'), dataIndex: 'afterData' }
])

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: fetch,
    tableId: _unref(tableIdByPath)('conversion')
  }, null, 8, ["columns", "tableId"]))
}
}

})